export enum CalendarioActionTypes {
  ACTION_SET_CONTEXTO = 'ACTION_SET_CONTEXTO',
}
